import { Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { colors } from "../../colors";
import BgImgTop from "../../components/BgImgTop/BgImgTop";
import CardSpectacleSlider from "../../components/CardSpectacleSlider/CardSpeactaclesSlider";
import Titles from "../../components/Titles/Titles";
import YoutubePlayer from "../../components/YoutubePlayer/YoutubePlayer";
import Gallery from "../../components/Gallery/Gallery";
import "./spectacleDetails.css";

const SpectacleDetails = ({ spectacles }) => {
	let { id } = useParams();
	const spectacle = spectacles.find((item) => item.id === id);
	const sections = [
		{
			id: 1,
			title: "Histoire",
			content: spectacle.histoire,
		},
		{
			id: 2,
			title: "Notes des auteurs",
			content: spectacle.notes_intention.auteurs,
		},
		{
			id: 3,
			title: "Mise en scène",
			content: spectacle.notes_intention.mise_en_scene,
		},
	];
	return (
		<div id="top" className={spectacle ? "" : "h-100"}>
			{spectacle && spectacle.length !== 0 && (
				<div>
					{/* BG IMAGE */}
					<BgImgTop
						image={spectacle.img_xl}
						title={spectacle.titre}
						subtitle={spectacle.mini_description}
						linkBtn={spectacle.youtube}
						linkName="Vidéo Youtube"
						avis={spectacle.avis}
					/>
					{/* Sections de contenu */}
					<div className="content-sections-wrapper container">
						{sections && sections.filter(section => section.content).map((section, index) => (
							<div className="content-section-card" key={section.id}>
								<div className="section-number">{String(index + 1).padStart(2, '0')}</div>
								<h2 className="section-title">{section.title}</h2>
								<div className="section-divider"></div>
								<p className="section-content">{section.content}</p>
							</div>
						))}
					</div>
					{/* GALERIE PHOTOS */}
					<Gallery images={spectacle.gallery} />
					{/* YOUTUBE */}
					<YoutubePlayer videos={spectacle.youtube_links} />
					<Container fluid>
						<Row>
							<div className="containerAgendaDansSpectacle">
								<Container>
									<Titles
										title="Les spectacles"
										color={colors.violetClair}
										margin="0px 0px 40px 0px"
									/>

									<CardSpectacleSlider
										data={spectacles.filter((s) => s.id !== id)}
										small={false}
										nbSlide={3}
									/>
								</Container>
							</div>
						</Row>
					</Container>
				</div>
			)}
		</div>
	);
};

export default SpectacleDetails;
